var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnIosShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-ios-share_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-ios-share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.308 21.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283v-9.384c0-.506.175-.933.525-1.283.35-.35.778-.525 1.283-.525h1.808c.212 0 .39.072.534.215a.726.726 0 01.215.535.726.726 0 01-.215.534.726.726 0 01-.534.216H6.308a.294.294 0 00-.212.096.294.294 0 00-.096.212v9.384c0 .077.032.148.096.212a.293.293 0 00.212.096h11.384a.294.294 0 00.212-.096.294.294 0 00.096-.212v-9.384a.294.294 0 00-.096-.212.294.294 0 00-.212-.096h-1.808a.726.726 0 01-.534-.216.726.726 0 01-.215-.534c0-.213.072-.391.215-.535a.726.726 0 01.534-.215h1.808c.505 0 .933.175 1.283.525.35.35.525.777.525 1.283v9.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308zM12 15.75a.725.725 0 01-.534-.216.725.725 0 01-.216-.534V4.72L9.927 6.041a.705.705 0 01-.522.22.742.742 0 01-.532-.235.784.784 0 01-.225-.527.7.7 0 01.225-.527l2.494-2.494A.831.831 0 0112 2.223a.831.831 0 01.633.256l2.494 2.494c.138.138.21.31.212.514a.749.749 0 01-.212.54.735.735 0 01-.535.233.735.735 0 01-.534-.233L12.75 4.719V15a.725.725 0 01-.216.535.725.725 0 01-.534.216z",
    fill: "#171413"
  }))));
}
export default SvgIcnIosShare;